import { Directive, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil, tap } from 'rxjs/operators';

@Directive()
export abstract class AbstractDebounceDirective implements OnDestroy {
	/**
	 * This is the base class to handle multiple debounce directives to handle different event
	 * and all common/shared logic between the different events we are debouncing.
	 */
	protected constructor() {
		// Default value is 500;
		this.debounceTime = 500;
		this.onEvent = new EventEmitter<any>();
		this.emitEvent = new Subject<any>();
		this.subscription = new Subject<void>();
	}

	@Input() debounceTime: number;
	@Output() onEvent: EventEmitter<any>;
	protected emitEvent: Subject<any>;
	protected subscription: Subject<void>;

	emitChange(value: any): void {
		this.onEvent.emit(value);
	}

	ngOnInit(): void {
		this.emitEvent
			.pipe(
				takeUntil(this.subscription),
				debounceTime(this.debounceTime),
				distinctUntilChanged(),
				tap((value) => this.emitChange(value))
			)
			.subscribe();
	}

	ngOnDestroy(): void {
		this.subscription.next();
		this.subscription.complete();
	}
}
